import api from './api';

// ============================================================
// Service da camada de Alertas Proativos (T2 / Camada 2).
// Espelha back/controller/alertas/Controller.Alerta.pas:
//   GET    /v1/alertas
//   GET    /v1/alertas/contar
//   POST   /v1/alertas/:id/lido
//   POST   /v1/alertas/:id/resolvido
//   POST   /v1/alertas/:id/arquivado
//   POST   /v1/alertas/marcar-todos-lidos
//   GET    /v1/alertas/regras
//   PUT    /v1/alertas/regras/:id
//   GET    /v1/alertas/engine/status
// ============================================================

const BASE = '/v1/alertas';

export const listarAlertas = async (params = {}) => {
  const { data } = await api.get(BASE, { params });
  return data;
};

export const contarAlertas = async () => {
  const { data } = await api.get(`${BASE}/contar`);
  return data;
};

export const marcarLido = async (id) => {
  const { data } = await api.post(`${BASE}/${id}/lido`);
  return data;
};

export const marcarResolvido = async (id) => {
  const { data } = await api.post(`${BASE}/${id}/resolvido`);
  return data;
};

export const marcarArquivado = async (id) => {
  const { data } = await api.post(`${BASE}/${id}/arquivado`);
  return data;
};

export const marcarTodosLidos = async () => {
  const { data } = await api.post(`${BASE}/marcar-todos-lidos`);
  return data;
};

export const listarRegras = async () => {
  const { data } = await api.get(`${BASE}/regras`);
  return data;
};

export const atualizarRegra = async (id, payload) => {
  const { data } = await api.put(`${BASE}/regras/${id}`, payload);
  return data;
};

export const obterStatusEngine = async () => {
  const { data } = await api.get(`${BASE}/engine/status`);
  return data;
};

// Mapeamento severidade -> cor/icone para UI consistente.
export const SEVERIDADE_INFO = {
  critica: { label: 'Crítica', cor: 'danger', ordem: 1 },
  alta: { label: 'Alta', cor: 'warning', ordem: 2 },
  media: { label: 'Média', cor: 'info', ordem: 3 },
  baixa: { label: 'Baixa', cor: 'secondary', ordem: 4 },
};

export const STATUS_INFO = {
  novo: { label: 'Novo', cor: 'primary' },
  lido: { label: 'Lido', cor: 'secondary' },
  resolvido: { label: 'Resolvido', cor: 'success' },
  arquivado: { label: 'Arquivado', cor: 'dark' },
};

// Catalogo de codigos conhecidos -> link UI + icone.
// O backend e quem decide os codigos; aqui so enriquecemos para apresentacao.
//
// IMPORTANTE: o Phada nao tem rotas de detalhe com :id para esses recursos.
// O paraPagina aqui leva o usuario para a tela de LISTAGEM correspondente,
// passando o id como query param. As paginas de listagem podem evoluir
// para reagir ao parametro (focar/filtrar a linha) sem quebrar nada.
export const CATALOGO_REGRAS = {
  'estoque.minimo': {
    titulo: 'Estoque abaixo do mínimo',
    icone: 'package',
    paraPagina: (p) =>
      p?.idproduto
        ? `/cadastros/produtos?focus=${p.idproduto}`
        : '/cadastros/produtos',
  },
  'conta.vence_breve': {
    titulo: 'Conta a receber vencendo',
    icone: 'dollar-sign',
    paraPagina: (p) =>
      p?.idcontasreceber
        ? `/financas/contasreceber?focus=${p.idcontasreceber}`
        : '/financas/contasreceber',
  },
  'contapagar.vence_breve': {
    titulo: 'Conta a pagar vencendo',
    icone: 'credit-card',
    paraPagina: (p) =>
      p?.idcontaspagar
        ? `/financas/contaspagar?focus=${p.idcontaspagar}`
        : '/financas/contaspagar',
  },
  'nfe.rejeitada': {
    titulo: 'NF-e rejeitada',
    icone: 'alert-octagon',
    paraPagina: (p) =>
      p?.idnotafiscal ? `/fiscal/nfe?focus=${p.idnotafiscal}` : '/fiscal/nfe',
  },
};

const alertaService = {
  listarAlertas,
  contarAlertas,
  marcarLido,
  marcarResolvido,
  marcarArquivado,
  marcarTodosLidos,
  listarRegras,
  atualizarRegra,
  obterStatusEngine,
  SEVERIDADE_INFO,
  STATUS_INFO,
  CATALOGO_REGRAS,
};

export default alertaService;
